import {getConfiguredLevel} from "./configuration"
import {makeLogger} from "./makeLogger"
import type {LogWriter, Logger} from "./makeLogger"
export type {Logger}

// writer that writes to console
// eslint-disable-next-line no-console
const consoleWriter: LogWriter = (level, ...args) => console[level](...args)

// This can run browser- or server-side
const env = ("process" in globalThis
  ? globalThis.process.env
  : {}) as unknown as Record<string, string>

const debugEnv = env.DEBUG || ""

const motherLogger: Logger = makeLogger(
  getConfiguredLevel(env),
  consoleWriter,
  debugEnv,
)

export const getLogger = (tag: string) => motherLogger.subLogger(tag)
